<template>
  <div class="about">
    <!-- <div class="aboutNav" /> -->
    <!-- -----------------------在线招聘会 -->
    <CaseTop :topTitle="topTitle" :topType="topType" />

    <!-- ----------------------------产品概述 -->
    <ProjectMilitaryOverview :overViewText='overViewText' />


    <!-- ---------------------------应用场景 -->
    <div class="three" :style="{ width: this.threeWidth.width + 'px' }" style="height: 673px;">
      <div class="font3">
        <p>应用场景</p>
      </div>
      <div class="box">
        <AboutOneApplicationArea v-for="(item, index) in info" :key="index" :item="item" />
      </div>
    </div>

    <!-- --------------------------------------- 我们支持 -->
    <div class="four" :style="{ width: this.fourWidth.width + 'px' }" style="height: 804px;">
      <div class="RecruitFont4">
        <p style="width:9% ;height:20%">我们支持</p>
      </div>
      <div class="onlineAll" style="width: 100%; height:650px;position: relative; margin-top: 60px;">
        <div class="online-all" style="width: 1206px; height:594px">
          <!-- 上面一排两个 -->
          <div class="topRecruit" style="width: 1206px; height: 307px">

            <div class="top-recruit">
              <AboutOnlineRecruits :recruitsItem="recruitItem1"></AboutOnlineRecruits>
            </div>

            <div class="top-recruit">
              <AboutOnlineRecruits :recruitsItem="recruitItem2"></AboutOnlineRecruits>
            </div>
          </div>

          <!-- 下面一排两个 -->
          <div class="bottomRecruit" style="width: 1206px; height:284px">
            <div class="bottom-recruit">
              <AboutOnlineRecruits :recruitsItem="recruitItem3"></AboutOnlineRecruits>
            </div>

            <div class="bottom-recruit">
              <AboutOnlineRecruits :recruitsItem="recruitItem4"></AboutOnlineRecruits>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- --------------------------------硬件支持 -->
    <div class="AboutOneHardwareSupport" :style="{ width: this.fiveWidth.width + 'px' }" style="height:535px">
      <!-- 实际案例 -->
      <Others :index="index" :currentType="currentType" :topType="topType" :arrayIndex="2" />
    </div>

    <!-- 关于我们 -->
    <div :style="{ width: this.sixWidth.width + 'px', height: this.sixWidth.height + 'px' }">
      <contactUs :pageType="1" />
    </div>

  </div>
</template>

<script>
// 顶部标题
import CaseTop from '../components/CaseTop.vue'
// 关于我们
import contactUs from '../components/contactUs.vue'
// 产品概述
import ProjectMilitaryOverview from '../components/ProjectMilitaryOverview.vue'
// 我们支持
import AboutOnlineRecruits from '../components/AboutOnlineRecruits.vue'
// 应用领域
import AboutOneApplicationArea from '../components/AboutOneApplicationArea.vue'
// 申请试用
import AboutOneApplyTryDiv from '../components/AboutOneApplyTryDiv.vue'
// 实际案例
import Others from '../components/Others.vue'


// 应用场景
import areaImg1 from '../assets/AboutOnlineRecruit/internet.png'
import areaImg2 from '../assets/AboutOnlineRecruit/manufacturingIndustry.png'
import areaImg3 from '../assets/AboutOnlineRecruit/educate.png'
import areaImg4 from '../assets/AboutOnlineRecruit/server.png'

// 我们支持
import goodImg1 from '../assets/AboutOnlineRecruit/figure.png'
import goodImg2 from '../assets/AboutOnlineRecruit/viedo.png'
import goodImg3 from '../assets/AboutOnlineRecruit/dataReports.png'
import goodImg4 from '../assets/AboutOnlineRecruit/function.png'


export default {
  name: 'AboutOneView',
  components: {
    CaseTop,
    ProjectMilitaryOverview,
    AboutOnlineRecruits,
    contactUs,
    AboutOneApplyTryDiv,
    AboutOneApplicationArea,
    Others
  },
  mounted() {
    //加载后先计算一遍缩放比例
    this.Scale();
    //生成一个监听器：窗口发生变化从新计算计算一遍缩放比例
    window.addEventListener('resize', this.Scale);

    // 实际案例部分

    //获取图片样式
    this.slides = document.querySelectorAll('.slide');
    //根据索引居中
    this.centerSlide(this.currentIndex);
    // 定时器  自动轮播，每3秒切换一次图片
    this.startTime();

  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    clearInterval(this.startTime);
  },
  data() {
    return {
      oneWidth: {
        width: '1920',
        height: '400'
      },
      twoWidth: {
        width: '1919',
        height: '472'
      },
      threeWidth: {
        width: '1919',
        height: '614'
      },
      fourWidth: {
        width: '1920',
        height: '802'
      },
      fiveWidth: {
        width: '1920',
        height: '2001'
      },
      sixWidth: {
        width: '1920',
        height: '533'
      },
      // 顶部标题
      topTitle: '在线招聘会',
      topType: 0,
      
      // 产品概述
      overViewText: '在线招聘会是指在网络上举办的大型招聘会，是各用人单位和求职者之间一个高效、便捷、务实的就业信息交流服务平台，招聘者和应聘者均通过网络进行报名，填写职位需求，建立应聘者库和招聘方库，通过应聘者和招聘方的意愿进行匹配，智能匹配双方需求度最高的进行线上面试，通过面对面直播间交流达成双方意愿，促成入职，并做后续跟进',
      // 在线支持
      recruitItem1: { title: '雇主形象包装', text: '自定义品牌包装，搭建企业自有招聘平台，支持企业宣传片播放，展示企业实力同时方便求职者快速了解企业文化', icon: goodImg1, iconWidth: '72.6', iconHeight: '36.7',iconTop:'43',iconLeft:'16' },
      recruitItem2: { title: '视频热区分析', text: '招聘不受人数限制，可面向数万求职者，简历投递、连麦问答，候选人与面试官直面沟通，节省时间和金钱，支持异地嘉宾一键连线', icon: goodImg2, iconWidth: '77', iconHeight: '37',iconTop:'43',iconLeft:'10' },
      recruitItem3: { title: '数据报表分析', text: '可视化数据看板，全流程数据评估与分析，一键导出招聘结果，包括应聘者数量、地域分布、直播观看时长、观看设备、来源渠道等', icon: goodImg3, iconWidth: '77', iconHeight: '37' ,iconTop:'43',iconLeft:'7'},
      recruitItem4: { title: '功能定制开发', text: '支持系统定制开发，内外部招聘渠道全线打通，人才一网打尽，支持全终端观看，多渠道引流（网站/公众号/小程序/APP等），多形式多维度触达求职者', icon: goodImg4, iconWidth: '77', iconHeight: '38',iconTop:'47',iconLeft:'18' },


      // 实际案例
      index: -1,
      currentType: 1,

      carText1: '机动实操考核系统',
      carText2: '设备台站模拟训练系统',
      carText3: '红蓝双方兵力对抗系统',
      carImage1: areaImg1,
      carImage2: areaImg2,
      carImage3: areaImg3,
      carFieldImgs: [areaImg1, areaImg2, areaImg3],
      carFieldTexts: ['机动实操考核系统', '设备台站模拟训练系统', '红蓝双方兵力对抗系统'],

      currentIndex: 0,//当前显示的图片索引

      intervalId: null, //用于存储定时器ID


      // 应用领域
      info: [

        { p1: '互联网行业', span: '互联网行业作为新技术、新应用的聚集地，对人才的需求具有快速变化、高度专业化的特点。通过实时更新人才库，确保企业能够第一时间获取到最新的人才信息。同时，平台还能够根据企业的具体需求，快速筛选出具备相关技术能力和项目经验的候选人，满足企业快速发展的需求', isActive: false, backgroundImage: areaImg1 },
        { p1: '制造业', span: '造业作为国民经济的重要支柱，对技能型人才的需求量大且持续。然而，由于技能型人才的培养周期长、流动性大等原因，企业往往难以招到合适的人才在线招聘通过网络人才库进行匹配，能够帮助企业找到具备相关技能和经验的候选人', isActive: false, backgroundImage: areaImg2 },
        { p1: '教育行业', span: '教育行业对人才的需求具有多样性和复杂性的特点。通过优化招聘流程，提高了招聘效率。能够自动筛选和分类简历，减少了HR的工作量。同时，还能够根据学校的特色和岗位需求，推荐合适的候选人。此外，平台还提供了在线面试和评估功能，使得招聘过程更加便捷和高效', isActive: false, backgroundImage: areaImg3 },
        { p1: '服务业', span: '服务业作为劳动密集型行业，对人才的需求具有多样化和灵活性的特点。通过精准的人岗匹配技术，提升了招聘质量。能够根据企业的服务特点和岗位需求，推荐具备相关服务技能和经验的候选人。此外，还提供了灵活的招聘方案，满足企业不同规模和不同阶段的招聘需求', isActive: false, backgroundImage: areaImg4 }
      ],
    }
  },
  methods: {
    Scale() {
      if (document.body.clientWidth < 1200) {
        this.oneWidth.width = 1200;
        this.oneWidth.height = 250;

        this.twoWidth.width = 1200;
        // this.twoWidth.height = 295

        this.threeWidth.width = 1200;
        // this.threeWidth.height = 616;

        this.fourWidth.width = 1200;
        // this.fourWidth.height = 503

        this.fiveWidth.width = 1200;
        // this.fiveWidth.height = 1251

        this.sixWidth.width = 1200;
        this.sixWidth.height = 333
      } else {
        this.oneWidth.height = 0.21 * document.body.clientWidth;
        this.oneWidth.width = document.body.clientWidth;

        // this.twoWidth.height = 0.25 * document.body.clientWidth;
        this.twoWidth.width = document.body.clientWidth;
        // 0.32 * document.body.clientWidth;
        // this.threeWidth.height = 616;
        this.threeWidth.width = document.body.clientWidth;

        // this.fourWidth.height = 0.42 * document.body.clientWidth;
        this.fourWidth.width = document.body.clientWidth;

        // this.fiveWidth.height = 1.04 * document.body.clientWidth;
        this.fiveWidth.width = document.body.clientWidth;

        this.sixWidth.height = 0.28 * document.body.clientWidth;
        this.sixWidth.width = document.body.clientWidth;
      }
    },

    /*锁定选定的盒子判断他是否选定 */
    // divClick(index) {
    //   /** 当 “点击” 一个“已被点击”的div时 使该div恢复默认色 */
    //   // 遍历info数组中的每个对象
    //   for (let i of this.info) {
    //     // 判断当前对象是否和传入的索引index对应 如果是，则取反
    //     if (index === this.info.indexOf(i)) {
    //       i.isActive = !i.isActive
    //     } else {
    //       i.isActive = false;
    //     }
    //   }
    // },

    // 鼠标滑过时，显示背景图片和修改文字颜色
    mouseOver(index) {
      this.info[index].isActive = true;
    },

    // 鼠标离开时则恢复默认
    mouseLeave(index) {
      this.info[index].isActive = false;
    },


    /*给选定的盒子修改样式 */
    colorDiv(index) {
      if (this.info[index].isActive) {
        return {
          backgroundImage: `url(${this.info[index].backgroundImage})`,
          color: 'white'
        };
      } else {
        return {
          backgroundImage: 'none',
          '.p1 p': {
            color: '#333333;'
          },
          '.span span': {
            color: 'black'
          }
        }
      }
    },

    /*
    实际案例部分轮播切换
     */
    showSlide(index) {
      this.carImage1 = this.carFieldImgs[index];
      this.carText1 = this.carFieldTexts[index];
      this.carImage2 = this.carFieldImgs[++index % 3];
      this.carText2 = this.carFieldTexts[index % 3];
      this.carText3 = this.carFieldTexts[++index % 3];
      this.carImage3 = this.carFieldImgs[index % 3];
      this.currentIndex = (++index) % 3;
    },
    //居中显示
    centerSlide(index) {
      this.currentIndex = index;
      this.showSlide(index);
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.carFieldImgs.length;
      this.currentIndex = (this.currentIndex + 1) % this.carFieldTexts.length;
      this.showSlide(this.currentIndex);
    },

    // 定时器 自动轮播
    startTime() {
      this.intervalId = setInterval(this.nextSlide, 5000);
    },

    chanageImg(index) {
      /* 重置计时器 */
      clearInterval(this.intervalId);
      this.currentIndex = index;
      //  // 将被点击的图片居中显示
      // this.centerSlide(this.currentIndex);

      //计算需要移动的步数
      let steps = index - this.currentIndex;

      // 如果步数大于轮播图一半的长度，向前滚动到达目标图片
      if (Math.abs(steps) > this.slides.length / 2) {
        steps = steps > 0 ? steps - 3 : steps + 3;
      }

      // 更新 currentIndex，使目标图片移动到中间位置
      this.currentIndex = (this.currentIndex + steps + 3) % 3;

      // 将目标图片居中显示
      this.centerSlide(this.currentIndex);

      //重新启动定时器
      this.startTime();
    },

    // 主要功能部分切换功能
    changeContent() {
      // 在页面加载完成后先执行这个
      // document.addEventListener("DOMContentLoaded",function(){
      //   // 获取第一个菜单项
      //   var firstMenuItem = document.querySelector('.menu-router');
      //   // 让他点击第一个菜单项
      //   firstMenuItem.click();
      // })

      // 获取元素
      // var tab_list = document.querySelector('.menu');
      var list = document.querySelectorAll('.menu-router');
      var item = document.querySelectorAll('.contentItem');

      // item[0].style.display='block';
      // 获取第一个导航项
      var firstNavItem = document.querySelectorAll('.menu-router')[6];
      //获取第一个导航项对应的内容
      var firstContentItem = document.querySelectorAll('.contentItem')[6];
      // 给导航项添加样式
      firstNavItem.classList.add('menuActive');
      // 让第一导航项对应内容默认显示
      firstContentItem.style.display = 'block';

      // 分别绑定点击事件
      for (var i = 0; i < list.length; i++) {
        // 在这里创建属性，添加索引
        list[i].setAttribute('index', i);
        list[i].onclick = function () {
          // 1.第一大步骤，先解决导航栏的颜色切换
          // 所有的 menu-router清除class类
          for (var i = 0; i < list.length; i++) {
            list[i].classList.remove('menuActive');
          }
          // 自己添加上这个类
          this.classList.add('menuActive');
          // 2.第二大步骤：下面模块跟着选项卡一一匹配
          // 给上面的tab_list里面所有的li添加索引
          var index = this.getAttribute('index');
          console.log(index);
          // 先全部隐藏
          for (var j = 0; j < item.length; j++) {
            item[j].style.display = 'none';
          }
          // 当前的显示
          item[index].style.display = 'block';
        }
      }
    },


  },
}

</script>


<style>
.about {
  width: 100%;
  height: auto;
}

.aboutNav {
  width: 100%;
  height: 90px;
  background-color: #000;
}

.three {
  /* width: 1202px;
	height: 663px; */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
  background-color: #f6f6f6;
}

.font3 {
  width: 100%;
  height: 116px;
}

.font3 p {
  font-family: MySourceHanSansSC-Heavy;
  font-size: 40px;
  line-height: 30px;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #333333;
  white-space: nowrap;
  margin: 0 auto;
}

.box {
  width: 1200px;
  height: 390px;
  display: flex;
  justify-content: space-between;
  /*间隔均匀排列*/
  justify-content: center;
  /* margin: 0 auto; */
  margin: 0;
}

.four {
  background-image: url(' ../assets/mainFunctions.jpg ');
  background-size: cover;
}

.RecruitFont4 {
  width: 100%;
  height: 98px;
  display: flex;
  white-space: nowrap;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  /*水平居中 */
  /*align-items: center; 垂直居中*/
  position: relative;
  /*相对定位 */
}

.RecruitFont4 p {
  font-family: SourceHanSansSC-Heavsy;
  font-size: 40px;
  line-height: 30px;
  font-weight: bold;
  font-stretch: normal;
  /* line-height: 30px; */
  letter-spacing: 4px;
  color: #ffffff;
  margin: 0;
  position: absolute;
  /*绝对定位 */
  bottom: 20%;
  /*让他的下边距为0 */
  /* margin-top: 50%; */
  /* margin-bottom: 50%; */
}


.onlineAll{
  display: flex;
  flex-direction: column;
  /*让整个容器垂直排列 */
  /* flex-wrap: wrap; */
  justify-content: space-between;
  align-items: center;
}

.online-all {
  /* margin: 0 auto; */
}


.topRecruit {
  display: flex;
  justify-content: space-between;
  margin: 0;
}

.bottomRecruit {
  display: flex;
  justify-content: space-between;
  margin: 0;
}

.top-recruit {
  width: 49%;
  height: 92%;
  background-color: #ffffff;
  border-radius: 8px;
}

.bottom-recruit {
  width: 49%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 8px;
}

.AboutOneHardwareSupport {
  /* margin: 0 auto; */
  /* display: flex;
 justify-content: center; */
  /* margin-top: 4%; */
  background-color: #f6f6f6;
}


/* 实际案例标题 */
.font6 h2 {
  font-family: SourceHanSansSC-Heavy;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 4px;
  color: #333333;
  margin: 0;
}


/* -----------------1201-1366之间---------------- */
@media (min-width: 1201px) and (max-width:1366px) {

  /* 实际案例标题 */
  .font6 h2 {
    font-size: 25px;
  }

}


/* -----------------1367-1600之间---------------- */
@media (min-width: 1367px) and (max-width:1600px) {

  /* 实际案例标题 */
  .font6 h2 {
    font-size: 30px;
  }
}


/* -----------------1600以上---------------- */
@media (min-width: 1600px) {

  /* 实际案例标题 */
  .font6 h2 {
    font-size: 40px;
  }


}
</style>